<script lang="ts" context="module">
  import { z } from 'zod';

  export const JobContentSchema = z.object({
    brandColor: z.string()
  });
</script>

<script lang="ts">
  import he from 'he';
  import { ResponsiveVars } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';

  export let content: string | undefined;

  const responsiveVars = new ResponsiveVars()
    .addFluid('details-p-font-size', toFluidVarInput(14, 18))
    .addFluid('details-h4-font-size', toFluidVarInput(20, 36)) // equivalent to h4
    .addFluid('gap', toFluidVarInput(12, 36))
    .addFluid('li-mb', toFluidVarInput(2, 2))
    .toCSS();
</script>

<div class={responsiveVars} data-testid="job-about">
  {#if content}
    {@html he.decode(content)}
  {/if}
</div>

<style lang="scss">
  div {
    display: flex;
    flex-direction: column;
    gap: var(--gap);
    // p2 text styles
    font-family: var(--twist-font-family-pilat);
    font-weight: 400;
    font-size: var(--details-p-font-size);
    line-height: 140%;

    :global(h1),
    :global(h2),
    :global(h3),
    :global(h4),
    :global(h5),
    :global(h6) {
      // all headings should match h4 styles
      font-weight: 700;
      font-size: var(--details-h4-font-size);
      line-height: 115%;
    }

    :global(a) {
      color: black;
      transition: color var(--twist-duration-200) var(--twist-ease-out-1);

      &:hover {
        color: var(--theme-job-content-brand-color);
      }
    }

    :global(ul),
    :global(ol) {
      margin: 0;
      padding: 0;
      list-style-position: inside;
    }

    :global(li) {
      display: list-item;
      margin-bottom: var(--margin-bottom);

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    :global(li p) {
      display: inline;
    }

    & > :global(section),
    & > :global(div) {
      display: flex;
      flex-direction: column;
      gap: var(--gap);
    }

    :global(.content-pay-transparency) {
      display: block;
    }
  }
</style>
